import { visserApi } from './visserApi';
const getAllPermissions = () => {
    return visserApi.get('RolePermission/GetAllPermissions');
};
const getRolePermissionsById = (roleId) => {
    return visserApi.get(`RolePermission/GetRolePermissionById/${roleId}`);
};
const getRolePermissionsByRoleName = (role) => {
    return visserApi.get(`RolePermission/getRolePermissionsByRoleName/${role}`);
};
const createRolePermission = (rolePermission) => {
    return visserApi.post('RolePermission/CreateRolePermission', rolePermission);
};
const updateRolePermission = (rolePermission) => {
    return visserApi.put(`RolePermission/UpdateRolePermission`, rolePermission);
};
const UserApi = {
    getAllPermissions,
    getRolePermissionsById,
    createRolePermission,
    updateRolePermission,
    getRolePermissionsByRoleName
};
export default UserApi;
